// extracted by mini-css-extract-plugin
export default {"backButton":"QuestionBackButton_backButton__wb6fd"};